import { AUTH } from '@constants/actions';
import { Map } from 'immutable';

const initialState = Map({
  validation: {
    valid: undefined
  }
});

const Auth = (state = initialState, action) => {
  switch (action.type) {
    case AUTH.VALIDATION.RESULT: {
      return state.setIn(['validation', 'valid'], action.payload.valid);
    }
    default:
      return state;
  }
};

export default Auth;